import { savedViewApi } from "../../app/apislices/savedViewApi";
import { thresholdApi } from "../../app/apislices/thresholdApi";
import { CustomAutocompleteState, CustomAutocompleteValues } from "./customAutocompleteTypes";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: CustomAutocompleteState = {
  instances: {},
};

const customAutocompleteSlice = createSlice({
  name: "customAutocomplete",
  initialState,
  reducers: {
    addInstance: <OptionType,>(state, action: PayloadAction<string>) => {
      if (!(action.payload in state.instances)) {
        const values: CustomAutocompleteValues<OptionType> = {
          selected: null,
          inputValue: "",
          selectedGroups: [],
          openGroups: [],
        };
        state.instances[action.payload] = values;
      }
    },
    addInstanceAndSetInitialValue: <OptionType,>(state, action: PayloadAction<[string, OptionType | OptionType[]]>) => {
      if (!(action.payload[0] in state.instances)) {
        const values: CustomAutocompleteValues<OptionType> = {
          selected: action.payload[1],
          inputValue: "",
          selectedGroups: [],
          openGroups: [],
        };
        state.instances[action.payload[0]] = values;
      }
    },
    setSelected: (state, action: PayloadAction<[string, any]>) => {
      state.instances[action.payload[0]].selected = action.payload[1];
    },
    setInputValue: <OptionType,>(state, action: PayloadAction<[string, string]>) => {
      if (!(action.payload[0] in state.instances)) {
        const values: CustomAutocompleteValues<OptionType> = {
          selected: null,
          inputValue: "",
          selectedGroups: [],
          openGroups: [],
        };
        state.instances[action.payload[0]] = values;
      }
      state.instances[action.payload[0]].inputValue = action.payload[1];
    },
    setSelectedGroups: (state, action: PayloadAction<[string, string[]]>) => {
      state.instances[action.payload[0]].selectedGroups = action.payload[1];
    },
    setOpenGroups: (state, action: PayloadAction<[string, string[]]>) => {
      state.instances[action.payload[0]].openGroups = action.payload[1];
    },
    reset: <OptionType,>(state, action: PayloadAction<string>) => {
      const values: CustomAutocompleteValues<OptionType> = {
        selected: null,
        inputValue: "",
        selectedGroups: [],
        openGroups: [],
      };
      state.instances[action.payload] = values;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(thresholdApi.endpoints.getThresholdGetStandards.matchFulfilled, (state, action) => {
      if (state.instances["pqIndexThresholdStandards"]) {
        state.instances["pqIndexThresholdStandards"].selected = action.payload.at(0);
        state.instances["pqIndexThresholdStandards"].inputValue = action.payload.at(0)!;
      }
    });
  },
});

export const { addInstance, addInstanceAndSetInitialValue, setSelected, setInputValue, setSelectedGroups, setOpenGroups, reset } =
  customAutocompleteSlice.actions;

export default customAutocompleteSlice.reducer;
